import axios from "@/plugins/axios";

export default {
    actions: {
        searchProductDynamics(context, searchItem) {
            let url = "product_dynamics?page=" + searchItem.page

            if (searchItem.before) {
                url = url + '&createdAt[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&createdAt[after]=' + searchItem.after
            }

            if (searchItem.productName) {
                url = url + '&product.name=' + searchItem.productName
            }

            return axios.get(url)
                .then((response) => {
                    context.commit('updateProductDynamics', response.data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },

    },
    mutations: {
        updateProductDynamics(state, data) {
            state.productDynamics.days = data[0]
            state.productDynamics.productDynamics = data[1]
            state.productDynamics.totalItems = data[2]
        }
    },
    state: {
        productDynamics: {
            days: [],
            productDynamics: [],
            totalItems: [],
        }
    },
    getters: {
        getProductDays(state) {
            return state.productDynamics.days
        },
        getProductDynamics(state) {
            return state.productDynamics.productDynamics
        },
        getProductDynamicsTotalCount(state) {
            return state.productDynamics.totalItems
        }
    }
}
